import { GenericObject }    from '../../types'
import genMatcher           from '../../utils/gen-matcher'
import createAction         from '../redux-utils/create-action'
import { Action, Reducer }  from '../types'
import { ApplicationState } from './index'

export const REQUEST = 'REQUEST'
export const REQUESTED = 'REQUESTED'
export const REQUEST_FAILED = 'REQUEST_FAILED'
export const REQUEST_SUCCEEDED = 'REQUEST_SUCCEEDED'
export const REQUEST_RESET = 'REQUEST_RESET'

export interface Communication {
  error?: string,
  success: boolean,
  fetching: boolean,
}

const isRequestedAction = genMatcher(new RegExp(`^\\[.+] ${REQUESTED}`))
const isSucceededAction = genMatcher(new RegExp(`^\\[.+] ${REQUEST_SUCCEEDED}`))
const isFailedAction = genMatcher(new RegExp(`^\\[.+] ${REQUEST_FAILED}`))
const isResetAction = genMatcher(new RegExp(`^\\[.+] ${REQUEST_RESET}`))

export interface CommunicationState {
  [ namespace: string ]: Communication
}

const initial: CommunicationState = {}

const communication: Reducer<CommunicationState> = (
  state = initial,
  action,
) => {
  const {
    type,
    error,
    meta,
  } = action

  if (isRequestedAction(type)) {
    return {
      ...state,
      [ meta.namespace ]: {
        fetching: true,
        success: false,
      },
    }
  }

  if (isFailedAction(type)) {
    return {
      ...state,
      [ meta.namespace ]: {
        error,
        fetching: false,
      },
    }
  }

  if (isSucceededAction(type)) {
    return {
      ...state,
      [ meta.namespace ]: {
        fetching: false,
        success:  true,
      },
    }
  }

  if (isResetAction(type)) {
    return {
      ...state,
      [ meta.namespace ]: {},
    }
  }

  return state
}

export default communication

export const requested = (namespace: string) =>
  createAction(
    `[${namespace}] ${REQUESTED}`,
    null,
    { namespace },
  )

export const failedRequest = (namespace: string, error: string) =>
  createAction(
    `[${namespace}] ${REQUEST_FAILED}`,
    null,
    { namespace },
    error,
  )

export const successfulRequest = (namespace: string) =>
  createAction(
    `[${namespace}] ${REQUEST_SUCCEEDED}`,
    null,
    { namespace },
  )

type SuccessHandler =
  | Action<any>
  | ((response: any, ...args: any []) => Action<any>)

export interface RequestMeta extends GenericObject {
  request: (...args: any []) => Promise<any>
  namespace: string
  successHandler?: SuccessHandler
}

export interface RequestAction {
  type: typeof REQUEST
  payload: { args: any [] },
  meta: RequestMeta
}

// type CreateRequestAction  = (meta:  & GenericObject) =>

export const createRequest =
  <A extends any []> (meta: {
    request: (...args: A) => Promise<any>
    namespace: string
    successHandler?: SuccessHandler,
  }): {
    actionCreator: (...args: A) => Action<any>,
    communicationSelector: CommunicationSelector,
    resetActionCreator: () => Action<any>
  } => ({
    actionCreator: (...args: A) =>
                     createAction(
                       `[${meta.namespace}] ${REQUEST}`,
                       { args },
                       meta,
                     ),

    communicationSelector: createCommunicationSelector(meta.namespace),

    resetActionCreator: () => createAction(
      `[${meta.namespace}] ${REQUEST_RESET}`,
      null,
      { namespace: meta.namespace },
    )
  })

type CommunicationSelector = (state: ApplicationState) => Communication
type CreateCommunicationSelector = (namespace: string) => CommunicationSelector

export const createCommunicationSelector: CreateCommunicationSelector =
  namespace =>
    state =>
      state.communication[ namespace ] || {}



// WEBPACK FOOTER //
// ./src/redux/ducks/communication.duck.ts